import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Box, Stack, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { TextField } from '~/components'
import { bshSlice } from '~/store'
import Field from './Field'
import { useCopyViewerText, useParagraphContext } from './hooks'

const Alt = ({
  hidden = false,
  multiline = false,
  maxLength = 125,
  placeholder: placeholderProp,
  property = 'alt',
}) => {
  const { t } = useTranslation()
  const placeholder = placeholderProp ?? t('paragraph.alt')

  const { canEdit, editable, paragraph } = useParagraphContext(Alt.name)
  const copyViewerText = useCopyViewerText(canEdit)
  const viewerFieldSx = useMemo(
    () => (canEdit ? undefined : { cursor: 'pointer' }),
    [canEdit]
  )

  const value = useMemo(() => {
    return paragraph[property]
  }, [paragraph, property])

  const containsEmpCo = useSelector((state) =>
    bshSlice.containsEmpCo(state, paragraph[property])
  )

  if (hidden) return null

  return (
    <Stack className="grow">
      <Field
        name={property}
        render={(fieldProps) => (
          <Box onClick={() => copyViewerText(value)} sx={viewerFieldSx}>
            <TextField
              fullWidth
              editable={editable}
              highlighted={containsEmpCo}
              multiline={multiline}
              placeholder={placeholder}
              size="small"
              value={value || ''}
              {...fieldProps}
            />
          </Box>
        )}
        submitOnEnter={!multiline}
      />
      <Typography
        variant="caption"
        className={value?.length > maxLength ? 'text-danger' : undefined}
      >
        {value?.length || 0} {t('ui.characters', { count: value?.length || 0 })}
      </Typography>
    </Stack>
  )
}

Alt.propTypes = {
  hidden: PropTypes.bool,
  multiline: PropTypes.bool,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  property: PropTypes.oneOf(['alt', 'caption']),
}

export default Alt
